import * as T from '../constants/types';
import { regions } from '../constants/regions';
import { SELECTED_REGION } from '../constants/variables';
import { fetchRegions } from '../utils/fetchRegions';

export const onChangeRegions = ({ target: { value } }) => (dispatch, getState) => {
    const { map: { apiRegions } } = getState();
    const regionsList = apiRegions && apiRegions.length > 0 ? apiRegions : regions;
    const selectedRegion = regionsList.find(({ id }) => id === value);

    if (selectedRegion) {
        localStorage.setItem(SELECTED_REGION, selectedRegion.id);
        return dispatch({ type: T.CHANGE_REGION, payload: { selectedRegion } });
    }
};

export const loadRegions = () => dispatch => {
    const setRegions = regions => {
        dispatch({ type: T.SET_REGIONS, payload: { apiRegions: regions } });
    };

    fetchRegions(setRegions, dispatch);
};
